<sb-dialog-header>
  <h1 sb-dialog-title>
    @if (isExtension) {
      {{ 'Create contract extension' | translate }}
    } @else {
      {{ 'Create employment contract' | translate }}
    }
  </h1>
</sb-dialog-header>

<sb-dialog-content>
  @if (store.step() === 0) {
    <div class="mx-auto flex w-full max-w-3xl flex-col gap-xl">
      @if (progressState(); as state) {
        <detection-progress
          [state]="state"
          [ready]="store.scanFinished()"
          [fileName]="store.fileName()"
          (retry)="store.retry()"
          (uploadAgain)="store.reset()"
          (setUpManually)="setUpManually()"
        />
      } @else {
        <upload-step
          [isUploading]="store.isUploading()"
          [rejection]="store.uploadRejection()"
          (fileSelected)="store.upload($event)"
          (setUpManually)="setUpManually()"
        />
      }
    </div>
  } @else {
    <div class="flex h-full w-full flex-col gap-xl">
      <sb-stepper variant="pill" [steps]="steps()" [currentStep]="store.step() - 1" />

      <div class="flex min-h-0 flex-1 flex-col gap-lg md:flex-row">
        <div class="flex min-h-0 shrink-0 flex-col md:w-2/5 md:overflow-y-auto">
          @switch (store.step()) {
            @case (1) {
              <who-signs-step
                [fields]="store.dataOrEmpty().fields"
                [notices]="store.dataOrEmpty().notices"
                [isDownloading]="store.isDownloading()"
                [downloadFailed]="store.downloadFailed()"
                [guardianCount]="store.guardianCount()"
                [noDigitalSignature]="store.noDigitalSignature()"
                (guardianCountChange)="store.setGuardianCount($event)"
                (noDigitalSignatureChange)="store.setNoDigitalSignature($event)"
                (download)="store.download()"
                (upload)="store.upload($event)"
              />
            }
            @case (2) {
              <check-fields-step
                [cards]="store.visibleCards()"
                [decisions]="store.blankDecisions()"
                (decided)="applyDecisions($event)"
                (upload)="store.upload($event)"
              />
            }
          }
        </div>

        <div
          class="flex min-h-0 min-w-0 flex-1 items-center justify-center rounded-md border border-default p-2xl md:order-first"
        >
          <sb-empty-state
            icon="document-2-regular"
            [description]="'The document preview will show here.' | translate"
          />
        </div>
      </div>
    </div>
  }
</sb-dialog-content>

@if (store.step() > 0) {
  <sb-dialog-footer>
    <sb-dialog-footer-actions [align]="'end'">
      @switch (store.step()) {
        @case (1) {
          <button sb-button color="primary" type="button" (click)="store.goToStep(2)">
            {{ 'Continue' | translate }}
          </button>
        }
        @case (2) {
          <button sb-button color="secondary" type="button" (click)="store.goToStep(1)">
            {{ 'Back' | translate }}
          </button>
        }
      }
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
}
